module.exports = __webpack_public_path__ + "img/arrow-customize-house-left.31e1d9f1.svg";